import { useRouteData } from "@bcm-dev/bcms-vite";
import SuccessNotificationView from "compid/shared/views/Notifications/SuccessNotificationView";

/**
 * @function AddedBillerPrompt
 * @returns {React.Component}
 * @description Component to show the added biller prompt after adding a new biller through the long form workflow
 * @example
 * <AddedBillerPrompt />
 */
export default function AddedBillerPrompt(props) {
    // Get the data passed through the route
    const { route } = useRouteData();
    const isShown = route !== null && route.addedBiller !== undefined;

    const billerName = isShown ? route.addedBiller.billerName : "";
    const billerNumber = isShown ? route.addedBiller.billerNumber : "";

    return (
        <>
            { isShown && <SuccessNotificationView message={ <span>Success! <b data-point="Added_Biller_Name_Text">{ billerName } { billerNumber }</b> has been added to your list.</span> } showClose={ false } /> }
        </>
    );
}